/// <reference path="../../../node_modules/@types/jquery/index.d.ts" />

export interface SelectListItem {
    disabled: boolean;
    group: SelectListGroup;
    selected: boolean;
    value: string;
    text: string;
}

export interface SelectListGroup {
    disabled: boolean;
    name: string;
}

export enum SchedulingMethodType {
    NoScheduling = "NoScheduling",
    ContractorScheduling = "ContractorScheduling",
    SelfScheduling = "SelfScheduling",
    AssignmentWithoutScheduling = "AssignmentWithoutScheduling",
}

export class Utility {

    public static SendAntiForgery(): any {
        return { "__OITAntiforgeryField": $('input[name=__OITAntiforgeryField]').val() }
    }

    public static ShowCancelModal(): void {
        ($('#CancelModal').data("kendoDialog") as any)!.open();
    }

    public static OnOpen(): void{
        $("#cancelButton").slideUp();
        $("#submitButton").slideUp();
    }

    public static OnClose(): void{
        $("#cancelButton").slideDown();
        $("#submitButton").slideDown();
    }

    public static RedirectToHomeIndex(): void{
        const baseUrl = window.location.origin;
        window.location.href = `${baseUrl}/Home/Index`;
    }
}